import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import {
  CountrysideZoneDeletionPayload,
  DeletedCountrysideZoneData,
} from './countryside-zone-deletion.types';

export async function deleteCountrysideZoneService({ query: rawQuery }: CountrysideZoneDeletionPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.delete<DeletedCountrysideZoneData>(ENDPOINT.COUNTRYSIDES_ZONES, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
